import BaseEnemyAI from "@/game/pacman/components/ai/BaseEnemyAI";
import {IEnemyAI} from "@/game/pacman/interfaces/IEnemyAI";
import Phaser from "phaser";

export default class FlankAI extends BaseEnemyAI implements IEnemyAI {

    getTargetPosition(baseX: number, baseY: number): Phaser.Math.Vector2 {
        return new Phaser.Math.Vector2(baseX, baseY);
    }
}